import { MIconName } from 'views/MIcon/MIcon.model';

export enum LayersTypes {
  EV = 'EV',
  Booking = 'booking',
  Heat = 'heat',
}

export type IPickedLayer = { icon: MIconName; name: string; type: LayersTypes };
